import { initializeApp } from 'firebase/app';
import { logger } from '../../functions/src/logging';

type FirebaseApp = ReturnType<typeof initializeApp>;

// initializes the default firebase app
let damApp: FirebaseApp;
export const getDAMApp = () => {
  if (damApp) {
    return damApp;
  }

  try {
    damApp = initializeApp(
      {
        apiKey: process.env.FIREBASE_API_KEY,
        authDomain: process.env.FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBASE_DATABASE_URL,
        projectId: process.env.FIREBASE_PROJECT,
      },
      'damApp'
    );
  } catch (e) {
    logger.error(`damApp initialization error: ${e}`);
  } // duplicate initialization of default app

  return damApp;
};

let canopusApp: FirebaseApp;
export const getCanopusApp = () => {
  if (canopusApp) {
    return canopusApp;
  }

  try {
    canopusApp = initializeApp(
      {
        apiKey: process.env.FIREBASE_API_KEY,
        authDomain: process.env.FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBASE_CANOPUS_DATABASE_URL,
        projectId: process.env.FIREBASE_PROJECT,
      },
      'canopusApp'
    );
  } catch (e) {
    logger.error(`canopusApp initialization error: ${e}`);
  } // duplicate initialization

  return canopusApp;
};

let partyServiceApp: FirebaseApp;
export const getPartyServiceApp = () => {
  if (partyServiceApp) {
    return partyServiceApp;
  }

  try {
    partyServiceApp = initializeApp(
      {
        apiKey: process.env.FIREBASE_API_KEY,
        authDomain: process.env.FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBASE_PARTY_SERVICE_DATABASE_URL,
        projectId: process.env.FIREBASE_PROJECT,
      },
      'partyServiceApp'
    );
  } catch (e) {
    logger.error(`partyServiceApp initialization error: ${e}`);
  } // duplicate initialization

  return partyServiceApp;
};

let ifbApp: FirebaseApp;
export const getIFBApp = () => {
  if (ifbApp) {
    return ifbApp;
  }

  try {
    ifbApp = initializeApp(
      {
        apiKey: process.env.FIREBASE_API_KEY,
        authDomain: process.env.FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBASE_IFB_DATABASE_URL,
        projectId: process.env.FIREBASE_PROJECT,
      },
      'ifbApp'
    );
  } catch (e) {
    logger.error(`ifbApp initialization error: ${e}`);
  } // duplicate initialization

  return ifbApp;
};

let addressbooksApp: FirebaseApp;
export const getAddressbooksApp = () => {
  if (addressbooksApp) {
    return addressbooksApp;
  }

  try {
    addressbooksApp = initializeApp(
      {
        apiKey: process.env.FIREBASE_API_KEY,
        authDomain: process.env.FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBASE_ADDRESSBOOKS_DATABASE_URL,
        projectId: process.env.FIREBASE_PROJECT,
      },
      'addressbooksApp'
    );
  } catch (e) {
    logger.error(`addressbooksApp initialization error: ${e}`);
  } // duplicate initialization

  return addressbooksApp;
};
